


















import Vue from "vue";

export default Vue.extend({
  props: {
    breedId: String
  },

  computed: {
    cats() {
      return this.$store.state.cats.slice(0, 11);
    }
  }
});
